import SiteRender from '../microSite/core/components/render/siteRender'
import { MICRO_SITE_TYPE } from '@/constant/common'

export default {
  extends: SiteRender,
  data () {
    return {
      logo: {
        show: false,
        path: ''
      }
    }
  },
  computed: {
    type () {
      return MICRO_SITE_TYPE.onboarding
    }
  },
  created () {
    this.logo.show = true
    this.logo.path = this.$parent.logoPath
    this.pathPrefix = `/onboarding/${this.$route.params.invitationId}/site/${this.siteId}`
    this.initEventBus()
    this.initSitePages()
  },
  methods: {
    initEventBus () {
      this.$eventBus.$on('getMicroSiteNavigationLogo', callback => {
        callback(this.logo)
      })
      this.$eventBus.$on('microSiteNavigationLogoClick', this.onLogoClick)
    },
    onLogoClick () {
      const homePath = this.$parent.getOnboardingHomePath()
      if (homePath !== this.$route.path) {
        this.$router.push(homePath)
        this.$eventBus.$emit('setSelectMenuItem', 0)
      }
    }
  }
}
